/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggle_Prev_NextInputs */



/**
* | output |
* | --- |
* | "Toggle Prev/Next Event View" |
*
* @param {Toggle_Prev_NextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toggle_prev_next = /** @type {((inputs?: Toggle_Prev_NextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_Prev_NextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer la vue événement précédent/suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorherige/Nächste Ereignisansicht umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva la visualizzazione dell'evento precedente/successivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить просмотр предыдущего/следующего события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alternar vista de evento anterior/siguiente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换上一个/下一个事件视图")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のイベント/次のイベントビューを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछला/अगला इवेंट दृश्य टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar visualização de eventos anterior/seguinte")
	return /** @type {LocalizedString} */ ("Toggle Prev/Next Event View")
});